/**
 * The optional Latin store link chosen when opening a store (R2-D5, lead's
 * call; backend `STORE_SLUG_PATTERN` in apps/backend/src/modules/seller/types/
 * store-slug.types.ts — keep the two in step). Lowercase Latin letters, digits
 * and single hyphens, 3–40 characters, starting and ending with a letter or a
 * digit. Reserved and taken links are refused by the server with 409
 * `STORE_SLUG_TAKEN`.
 */
export const STORE_SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9]|-(?=[a-z0-9])){2,39}$/;

/**
 * What the field keeps while the seller types: lowercase, spaces and
 * underscores become hyphens, anything else outside [a-z0-9-] is dropped, and
 * runs of hyphens collapse. A trailing hyphen is kept so typing "my-" then
 * "shop" works; `isValidStoreSlug` refuses it until it is completed.
 */
export function sanitizeStoreSlugInput(value: string): string {
  return value
    .toLowerCase()
    .replace(/[\s_]+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-{2,}/g, "-")
    .replace(/^-+/, "")
    .slice(0, 40);
}

export function isValidStoreSlug(value: string): boolean {
  return STORE_SLUG_PATTERN.test(value);
}
